import React, { useEffect, useState } from "react";
import { LoadPanel } from "devextreme-react";
import { ToastDisplayer } from "../../../components/toastDisplay/ToastDisplayer";
import "./PriorityTab.scss";
import {
  getPriorityApi,
  addPriorityApi,
  editPriorityApi,
  deletePriorityApi,
} from "../../../api/settingsApi";

export default function PriorityTab() {
  const [loading, setLoading] = useState(false);
  const [priorityList, setPriorityList] = useState([]);
  const [priorityInput, setPriorityInput] = useState("");

  const [editingId, setEditingId] = useState(null);
  const [editingValue, setEditingValue] = useState("");

  //FETCH
  const fetchPriorities = async () => {
    try {
      setLoading(true);
      const data = await getPriorityApi();
      setPriorityList(data);
    } catch (error) {
      ToastDisplayer(
        "error",
        error?.response?.data?.message || "Failed to fetch priorities.",
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPriorities();
  }, []);

  // ── ADD ──────────────────────────────────────────────
  const handleAddPriority = async () => {
    if (!priorityInput.trim()) {
      ToastDisplayer("error", "Please enter a priority name.");
      return;
    }

    try {
      setLoading(true);
      await addPriorityApi({ name: priorityInput });
      ToastDisplayer("success", "Priority added successfully!");
      setPriorityInput("");
      fetchPriorities();
    } catch (error) {
      ToastDisplayer(
        "error",
        error?.response?.data?.message || "Failed to add priority.",
      );
    } finally {
      setLoading(false);
    }
  };

  // ── EDIT START ───────────────────────────────────────
  const handleEditClick = (item) => {
    setEditingId(item.id);
    setEditingValue(item.name);
  };

  // ── SAVE EDIT ────────────────────────────────────────
  const handleEditSave = async (id) => {
    if (!editingValue.trim()) {
      ToastDisplayer("error", "Priority name cannot be empty.");
      return;
    }

    try {
      setLoading(true);
      await editPriorityApi(id, { name: editingValue });
      ToastDisplayer("success", "Priority updated successfully!");
      setEditingId(null);
      setEditingValue("");
      fetchPriorities();
    } catch (error) {
      ToastDisplayer(
        "error",
        error?.response?.data?.message || "Failed to update priority.",
      );
    } finally {
      setLoading(false);
    }
  };

  const handleEditCancel = () => {
    setEditingId(null);
    setEditingValue("");
  };

  // ── DELETE ───────────────────────────────────────────
  const handleDelete = async (id) => {
    try {
      setLoading(true);
      await deletePriorityApi(id);
      ToastDisplayer("success", "Priority deleted successfully!");
      fetchPriorities();
    } catch (error) {
      ToastDisplayer("error", error?.response?.data?.error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {loading && <LoadPanel visible={true} />}

      <div className="priorityTabSec">
        <div className="priorityTabCard">
          <div className="priorityCardHead">
            <span className="priorityCardTitle">Manage Priorities Type</span>
          </div>

          <div className="priorityCardBody">
            {/* Input Row */}
            <div className="catInputRow">
              <div className="catInputWrap">
                <label className="catLabel">
                  Priority Name <span className="required">*</span>
                </label>
                <input
                  className="catTextBox"
                  placeholder="Enter Priority Name"
                  value={priorityInput}
                  onChange={(e) => setPriorityInput(e.target.value)}
                  onKeyDown={(e) => e.key === "Enter" && handleAddPriority()}
                />
              </div>
              <button className="catAddBtn" onClick={handleAddPriority}>
                Add Priority
              </button>
            </div>

            {/* List */}
            <div className="catListWrap" style={{height: "calc(100vh - 467px)" }}>
              <div className="catListHeader">
                <span>Priority Name</span>
              </div>

              {priorityList.length === 0 && !loading && (
                <div className="catEmptyMsg">No priorities found.</div>
              )}

              {priorityList.map((item) => (
                <div className="catListRow" key={item.id}>
                  {editingId === item.id ? (
                    <div className="catEditRow">
                      <input
                        className="catTextBox"
                        value={editingValue}
                        onChange={(e) => setEditingValue(e.target.value)}
                        onKeyDown={(e) => {
                          if (e.key === "Enter") handleEditSave(item.id);
                          if (e.key === "Escape") handleEditCancel();
                        }}
                        autoFocus
                      />
                      <button
                        className="catSaveBtn"
                        onClick={() => handleEditSave(item.id)}
                      >
                        ✓
                      </button>
                      <button
                        className="catCancelBtn"
                        onClick={handleEditCancel}
                      >
                        ✕
                      </button>
                    </div>
                  ) : (
                    <>
                      <span className="catRowText">{item.name}</span>
                      <div className="catRowActions">
                        <button
                          className="catIconBtn editIcon"
                          title="Edit"
                          onClick={() => handleEditClick(item)}
                        >
                          <i className="ri-pencil-line" />
                        </button>
                        <button
                          className="catIconBtn deleteIcon"
                          title="Delete"
                          onClick={() => handleDelete(item.id)}
                        >
                          <i className="ri-delete-bin-line" />
                        </button>
                      </div>
                    </>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
